import { render, staticRenderFns } from "./BDXEditFormBroker.vue?vue&type=template&id=2de1b47d&scoped=true"
import script from "./BDXEditFormBroker.vue?vue&type=script&lang=js"
export * from "./BDXEditFormBroker.vue?vue&type=script&lang=js"
import style0 from "./BDXEditFormBroker.vue?vue&type=style&index=0&id=2de1b47d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de1b47d",
  null
  
)

export default component.exports